import { ENVIRONMENTS } from 'constants-activate';

const { APP_ENV } = process.env;

const env =
  Object.values(ENVIRONMENTS).find(e => e === APP_ENV) ?? ENVIRONMENTS.LOCAL;

/// @deprecated Use libs/constants and APP_ENV injection instead
export default env;
